module.exports = "/assets/data/70fb1addbfe194eb5273c65daf801700-SE12.data.json";